export const DEFAULTS = {
    currency: "NGN",
    symbol: "₦",
    starter_monthly: 10000,
    starter_yearly: 48000,
};

export const PRICING: Record<string, typeof DEFAULTS> = {
  "Nigeria": {
    currency: "NGN",
    symbol: "₦",
    starter_monthly: 10000,
    starter_yearly: 48000,
  },
  "Ghana": {
    currency: "GHS",
    symbol: "GH₵",
    starter_monthly: 150,
    starter_yearly: 720,
  },
  "Kenya": {
    currency: "KES",
    symbol: "KSh",
    starter_monthly: 1500,
    starter_yearly: 7200,
  },
  "South Africa": {
   currency: "ZAR",
    symbol: "R",
    starter_monthly: 400,   
    starter_yearly: 1920,
  }
};